import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactService } from '../../../../api-services/contact.service';
import { WritingCodeNotes } from '../../../../models/user-carrier-details.model';
import { SharedService } from '../../../../services/shared.service';

@Component({
  selector: 'app-sidepanel-notes',
  templateUrl: './sidepanel-notes.component.html',
  styleUrls: ['./sidepanel-notes.component.css']
})
export class SidepanelNotesComponent implements OnInit {
  @Input() userId!: number;
  @Input() carrierId: number;
  writingCodeNoteRequest: WritingCodeNotes = {} as WritingCodeNotes;
  writingCodeNote: FormGroup;
  WritingCodeNotesList: WritingCodeNotes[] = [];
  constructor(private contactService: ContactService, private fb: FormBuilder, private sharedService: SharedService) { }

  ngOnInit(): void {
    if (this.userId) {
      this.writingCodeNote = this.fb.group({
        memo: ['', [Validators.required, Validators.maxLength(500)]]
      });
    }
    this.getWritingCodeNotes()
  }
  getWritingCodeNotes(): void {
    this.contactService.getWritingCodeNotes(this.userId, this.carrierId)
      .subscribe({
        next: (response: WritingCodeNotes[]) => {
          if (response) {

            this.WritingCodeNotesList = response.map(el => ({
              ...el,
              createdOn: el.createdOn
                ? this.sharedService.convertUTCTimeToLocalTime(el.createdOn)
                : el.createdOn
            }));

            this.WritingCodeNotesList = [...this.WritingCodeNotesList];
          }
        },
        error: (error) => {
          console.error(error);
        }
      });

  }


  insertNote(): void {

    if (this.writingCodeNote.invalid) {
      this.writingCodeNote.markAllAsTouched();
      return;
    }

    this.writingCodeNoteRequest = {
      carrierId: this.carrierId,
      userId: this.userId,
      tenantId: 0,
      note: this.writingCodeNote.get('memo')?.value,
      createdByUserId: this.userId,
      createdBy: ''
    };

    this.contactService.insertWritingCodeNote(this.writingCodeNoteRequest)
      .subscribe({
        next: () => {
          this.writingCodeNote.reset();
          this.getWritingCodeNotes();
        },
        error: (error) => {
          console.error(error);
        }
      });
  }

  get noteLength(): number {
    return this.writingCodeNote.get('memo')?.value?.length || 0;
  }

}
